import axios from "axios"
if (localStorage.getItem("userAuthScolarite")) {
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var token = userAuthScolarite
}
export default axios.create({
  withCredentials: true,
  baseURL: `https://scolarite.flshs.edura.backcresus-institut.ovh/api`,
  headers: {
    Authorization: `Bearer ${token}`,
    'X-Frame-Options' : "DENY",
    apipassword: "3KbmGc5tZhuDbPtb",
  },
})
